export enum GlobalStorageConfigSource {
    localStorage = 'localStorage',
    userConfiguration = 'userConfiguration',
    sessionStorage = 'sessionStorage',
}



// WEBPACK FOOTER //
// ./src/models/configuration/global/GlobalStorageConfigSource.ts